import React from "react";
import Slider from "@components/V3/Slider";
import { renderDate } from "@utils/dateUtils";
import "./style.scss";

const DateSelector = ({ uniqueDates, handleClickDate, selectedDate }) => {
    return (
        <Slider
            className="date-selector__date-list"
            arrowClass="date-selector__button"
            wrapperClass="date-selector__slider">
            {uniqueDates.map((date) => (
                <div
                    key={date}
                    className={`date-selector__date-item ${date === selectedDate ? "active" : ""}`}
                    role="button"
                    onClick={() => date !== selectedDate && handleClickDate(date)}
                        >
                    {renderDate(date)}
                </div>
            ))}
        </Slider>
    );
};

export default DateSelector;
